import styled from 'styled-components'

export const PageContent = styled.article`
  display: flex;
  background: #f8f7f7;
`